export default [
	{
		modulo: 16,
		privilegio: 115,
		routerName: 'quadro',
		routerPath: '/quadro-atividades',
		componentName: 'QuadroAtividades',
		componentPath: 'modules/layout/quadro-atividades/mg-siga/main',
		clientsComponentPath: [
			// id do ibama
			{
				clientId: [5],
				componentPath: 'modules/layout/quadro-atividades/ibama/main'
			},
			// id pm-es
			{
				clientId: [18],
				componentPath: 'modules/layout/quadro-atividades/mg-siga/main'
			},
			// id do siga, pmsp, bm-df
			{
				clientId: [9],
				componentPath: 'modules/layout/quadro-atividades/mg-siga/main'
			},
			// id do gta-sergipe
			{
				clientId: [24],
				componentPath: 'modules/layout/quadro-atividades/sergipe/main'
			},
			// id do maranhao
			{
				clientId: [10],
				componentPath: 'modules/layout/quadro-atividades/maranhao/main'
			},
			// id casa militar bahia
			{
				clientId: [8],
				componentPath: 'modules/layout/quadro-atividades/cm-bahia/main'
			},
			// id da henrimar
			{
				clientId: [25, 37],
				componentPath: 'modules/layout/quadro-atividades/vale/main'
			}
		]
	}
]
